import type { Transaction } from '../types'

export type InstallmentGroupItem =
  | { type: 'transaction'; transaction: Transaction }
  | {
      type: 'installmentGroup'
      groupId: string
      title: string
      category: string
      subcategory_id: string | null
      total: number
      count: number
      transactions: Transaction[]
      date: string
      isAnticipated: boolean
    }

export function groupInstallments(transactions: Transaction[]): InstallmentGroupItem[] {
  const grouped = new Map<string, Transaction[]>()
  const result: InstallmentGroupItem[] = []
  
  for (const t of transactions) {
    if (t.installment_group_id) {
      const arr = grouped.get(t.installment_group_id) || []
      arr.push(t)
      grouped.set(t.installment_group_id, arr)
    }
  }

  const anticipatedGroups = new Set<string>()
  for (const [id, arr] of grouped.entries()) {
    if (arr.length > 1) {
      anticipatedGroups.add(id)
    }
  }

  const seenGroups = new Set<string>()

  for (const t of transactions) {
    if (t.installment_group_id && anticipatedGroups.has(t.installment_group_id)) {
      if (seenGroups.has(t.installment_group_id)) continue
      seenGroups.add(t.installment_group_id)
      
      const arr = grouped.get(t.installment_group_id)!
      arr.sort((a, b) => (a.installment_index ?? 0) - (b.installment_index ?? 0))
      
      const baseTitle = arr[0].title.replace(/\s*\(\d+\/\d+\)\s*$/, '')
      
      result.push({
        type: 'installmentGroup',
        groupId: t.installment_group_id,
        title: baseTitle,
        category: arr[0].category,
        subcategory_id: arr[0].subcategory_id,
        total: arr.reduce((sum, tx) => sum + tx.amount, 0),
        count: arr.length,
        transactions: arr,
        date: t.date, // Use the date of the first encountered transaction to preserve list order
        isAnticipated: true
      })
    } else {
      result.push({ type: 'transaction', transaction: t })
    }
  }
  
  return result
}
